import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from 'prop-types';

import Dialog from 'components/common/material/Dialog';
import CSSModules from "react-css-modules";
import styles from "./cardMakeAPayment.scss";
import DebitCardForm from "../components/common/debitCardForm/DebitCardForm";
import AmountOptions from "./AmountOptions"
import PaymentMethodSelect from "./PaymentMethodSelect"
// not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
// import RCCForm from "../components/common/RCCForm/RCCForm";
import { FormattedMessage } from "react-intl";
import * as sunbitConstants from "constants/sunbit";
import RaisedButton from "components/common/material/RaisedButton";
import * as thunkActionHelpers from "utils/redux/thunkActionHelpers";
import * as cardActions from "./redux";
import _get from "utils/get";
import vSignImage from './public/vSign.png';
import { datadogRum } from '@datadog/browser-rum';
import NumberFormatter from "../utils/numberFormatter";
import InfoBox from "../components/common/info-box/info-box";
import { recurringPaymentAuthorizationLink } from "../auth/staticComponents";

const defaultPaymentErrorMessageKey = "card.autopay.error.PaymentProfileError";

@connect(
  state => ({
    card: state.card
  }),
  dispatch => ({
    getBalance: () => dispatch(cardActions.getBalance()),
    getCardAccount: () => dispatch(cardActions.fetch()),
    setAutoPay: (enabled, peymentMethodDetails) => dispatch(cardActions.setAutoPay(enabled, peymentMethodDetails)),
    // addPaymentMethod: (paymentProfile) => dispatch(cardActions.addPaymentMethod(paymentProfile)),
    getStatement: statementDate =>
      dispatch(cardActions.getStatement(statementDate))
  })
)
@CSSModules(styles, { allowMultiple: true })
class CardAutoPaySettings extends React.Component {

  static propTypes = {
    getBalance: PropTypes.func,
    getStatement: PropTypes.func,
    getCardAccount: PropTypes.func,
    // addPaymentMethod: PropTypes.func,
    setAutoPay: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      autoPay: _get(props, ['card', 'card', 'autoPaySetting', 'enabled'], false),
      actionFailed: false,
      autoPayStep: "PAYMENT_DETAILS",
      validPaymentDetails: true,
      amountOption: 'MINIMUM_PAYMENT',
      paymentMethod: 'CURRENT',
      debitCardDetails: undefined,
      autoPayMessageOn: false,
      // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
      // rccDetails: {},
      paymentInProcess:false,
      paymentErrorMessageKey: defaultPaymentErrorMessageKey,
      showDisclaimer: false,
      hasPaymentMethod: true,
    };
  }

  componentDidMount() {
    this.props.getCardAccount();
    this.props.getBalance();
    this.props.getStatement();
  }

  handlePaymentMethodSelection = (value) => {
    this.setState(() => ({paymentMethod: value}), this.setValidPaymentDetails);
  };

  handleDebitCardFormChange = (debitCardDetails, name) => {
    this.setState(() => ({[name]: debitCardDetails}), this.setValidPaymentDetails);
  };

  // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
  // handleRCCFormChange = (rccDetails) => {
  //   this.setState(() => ({rccDetails}), this.setValidPaymentDetails);
  // }

  showAutoPayOffMessage = (value) => {
    this.setState(() => ({autoPayMessageOn: value}));
  }

  handleAutoPaySwithChange = (value) => {
    const isAutopayOn = _get(this, ['props', 'card', 'card', 'autoPaySetting', 'enabled'], true);
    if (!value && isAutopayOn) {
      this.showAutoPayOffMessage(true);
    } else {
      this.setState(() => ({autoPay: value}));
    }
  }

  setAutoPayStep (autoPayStep) {
    this.setState(()=>({autoPayStep}));
  }

  setValidPaymentDetails () {
    let validPaymentDetails = false;

    // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
    // const routing = _get(this, ['state', 'rccDetails', 'routingNumber'], "");
    // const accountNumber = _get(this, ['state', 'rccDetails', 'accountNumber'], "");

    switch (this.state.paymentMethod) {
      case 'DEBIT':
        validPaymentDetails = Boolean(this.state.debitCardDetails);
        break;
      // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
      // case 'RCC':
      //   validPaymentDetails = routing.length === 9 && accountNumber.length >= 4;
      //   break;
      case 'CURRENT':
        validPaymentDetails = true;
        break;
    }


    this.setState(() => ({
      validPaymentDetails,
      showDisclaimer: validPaymentDetails && this.state.paymentMethod === "DEBIT"
    }));
  }

  getPaymentMethodString () {
    let last4Digits = "";
    let isDebit = true;
    let isACH = false;

    switch (this.state.paymentMethod) {
      case 'DEBIT':
        last4Digits = _get(this, ['state', 'debitCardDetails', 'cardNumber'], "").substr(-4);
        break;
      // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
      // case 'RCC':
      //   last4Digits = _get(this, ['state', 'rccDetails', 'accountNumber'], "").substr(-4);
      //   isDebit = false;
      //   break;
      case 'CURRENT':
        last4Digits = _get(this, ['props', 'card', 'card', 'paymentMethod', 'last4Digits'], null);
        isDebit = _get(this, ['props', 'card', 'card', 'paymentMethod', 'paymentMethodType']) === "DEBIT";
        isACH = _get(this, ['props', 'card', 'card', 'paymentMethod', 'paymentMethodType']) === "ACH";
        break;
    }

    let res;
    if (isDebit) {
      res = `Debit card ending in ${last4Digits}`;
    } else if (isACH) {
      res = `Bank account ending in ${last4Digits}`;
    } else {
      res = `RCC with account number ending in ${last4Digits}`;
    }
    return res;
  }

  submit () {
    const { validPaymentDetails, paymentMethod, debitCardDetails, autoPay } = this.state;
    let peymentMethodDetails = null;
    if (validPaymentDetails) {
      if (paymentMethod !== "CURRENT") {
        peymentMethodDetails = { "debitCardDetails": debitCardDetails };
        // the line above replaces the code in the comment, not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
        // peymentMethodDetails = paymentMethod === "RCC" ?
        // { "rccDetails": rccDetails } :
        // { "debitCardDetails": debitCardDetails };

        peymentMethodDetails.paymentMethodType = paymentMethod;
      }
    }
    this.props.setAutoPay(autoPay, peymentMethodDetails);
  }

  isPaymentSuccess(props) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      cardActions.CARD_SET_AUTOPAY,
      props.card.type,
      props.card.status
    );
  }

  isPaymentPending(props) {
    props = props || this.props;
    return thunkActionHelpers.actionPending(
      cardActions.CARD_SET_AUTOPAY,
      props.card.type,
      props.card.status
    );
  }

  isPaymentFailed(props) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      cardActions.CARD_SET_AUTOPAY,
      props.card.type,
      props.card.status
    );
  }

  renderNotPayableDialog() {
    const dialogTheme = {
      dialog: styles.dialogTheme
    };

    const closeDialog = () => {
      this.setState(() => ({
        actionFailed: false,
        autoPayStep: "PAYMENT_DETAILS",
      }));
    };

    return (
      <Dialog theme={dialogTheme} active={this.state.actionFailed}>
        <div styleName="dialogContent" data-at="dialog-content">
          <div data-at="payment-failed-dialog-close" styleName="closeIcon" onClick={closeDialog}>&nbsp;</div>
          <span data-at="dialog-text">
            <FormattedMessage
              data-at="autopay-save-failure-message"
              id={this.state.paymentErrorMessageKey}
              values={{ phoneNumber: sunbitConstants.PHONE_NUMBER }}
            />
          </span>
          <RaisedButton data-at="payment-failed-close-btn" onClick={closeDialog}>
            CLOSE
          </RaisedButton>
        </div>
      </Dialog>
    );
  }

  toggleNotPayableDialog (nextProps) {
    const errorCode = _get(nextProps, ["card", "card", "error", "response", "data", "code"], null);
    let paymentErrorMessageKey;
    switch (errorCode) {
      case "TransactionDeclined":
        paymentErrorMessageKey = "card.autopay.error.TransactionDeclined";
        break;
      case "bankruptAccount":
        paymentErrorMessageKey = "card.payment.error.bankrupt.account";
        break;
      case "WrongCardType":
        paymentErrorMessageKey = "card.autopay.error.WrongCardType";
        break;
      case "PaymentProfileError":
      default:
        paymentErrorMessageKey = defaultPaymentErrorMessageKey;
        break;
  }
    this.setState(()=>({
      actionFailed: true,
      paymentErrorMessageKey
    }));
  }

  componentWillReceiveProps(nextProps) {
    const autoPay = _get(nextProps, ['card', 'card', 'autoPaySetting', 'enabled'], this.state.autoPay);
    if (autoPay !== this.state.autoPay) {
      this.setState({autoPay});
    }

    const hasPaymentMethod = _get(nextProps, ['card', 'card', 'paymentMethod', 'paymentMethodType']) !== "UNSET";
    this.setState({
      hasPaymentMethod,
      paymentMethod: hasPaymentMethod ? "CURRENT" : "DEBIT",
      validPaymentDetails: hasPaymentMethod,
    });

    if (!this.isPaymentSuccess() && this.isPaymentSuccess(nextProps)) {
      datadogRum.addUserAction('Set autopay success', {
        customerId: nextProps.card.card.customerId
      });
      this.setState({
        autoPayStep: "CONFIRMATION",
        paymentInProcess: false,
        // completedPayment: nextProps.card.payment
      });
    }

    if (!this.isPaymentPending() && this.isPaymentPending(nextProps)) {
      this.setState({ paymentInProcess: true, completedPayment: {} });
    }

    if (!this.isPaymentFailed() && this.isPaymentFailed(nextProps)) {
      datadogRum.addUserAction('Set autopay failed', {
        customerId: nextProps.card.card.customerId,
        error: nextProps.card.error
      });
      this.toggleNotPayableDialog(nextProps);
      this.setState({ paymentInProcess: false });
    }
  }

  getSelectedRedNote = () => {
    const isACH = _get(this, ['props', 'card', 'card', 'paymentMethod', 'paymentMethodType']) === "ACH";
    if (isACH) {
      const isClosed = _get(this, ['props', 'card', 'card', 'defaultPaymentMethod', 'ach', 'isClosed']);
      if (isClosed) {
        return 'closed';
      }
    }
  }



  render() {
    const dialogTheme = {
      dialog: styles.dialogTheme
    };

    const balance = _get(this, ['props', 'card', 'balance'], {});
    const cardData = _get(this, ['props', 'card', 'card'], {});
    const last4Digits = _get(cardData, ['paymentMethod', 'last4Digits'], null);
    const dueDate = _get(this, ['props', 'card', 'card', 'dueDate'], null);

    const { autoPay, showDisclaimer } = this.state;

    const SummeryTable = (
      <div styleName="reviewTable">
        <div styleName="row">
          <div styleName="label" data-at="autopay-payment-method-title">Payment Method</div>
          <div styleName="value" data-at="autopay-payment-method-string">{this.getPaymentMethodString()}</div>
        </div>
        <div styleName="row">
          <div styleName="label" data-at="autopay-payment-amount-title">Amount</div>
          <div styleName="value" data-at="autopay-payment-amount-type">Minimum Payment</div>
        </div>
        <div styleName="row">
          <div styleName="label" data-at="autopay-date-title">Date Scheduled</div>
          <div styleName="value" data-at="autopay-date">{NumberFormatter.ordinalFormat(dueDate)}</div>
        </div>
      </div>
    );

    if (this.state.autoPayStep === "CONFIRMATION") {
      return (<div styleName="cardMakeAPayment confirmation">
        <header styleName="autoPayHeader">
          <img styleName="vSignImage" src={vSignImage} alt="v symbol"/>
          <h1 styleName="title" data-at="auto-pay-main-title-confirmation">Auto Pay is now active</h1>
          {autoPay && <p data-at="your-next-payment-scheduled" styleName="nextPaymentDateMessage">Your next payment is scheduled for {moment(balance.paymentDueDate).format("MM/DD/YYYY")}</p>}
        </header>

        {SummeryTable}

        <section styleName="disclaimer">
          If your payment due date is today any changes to your Auto Pay settings may not affect your current payment.
          <br/>
          Please ensure your payment is made on time and contact us if you need any assistance.
        </section>
      </div>);
    }

    if (this.state.autoPayStep === "REVIEW") {
      return (<div styleName="cardMakeAPayment">
        <header styleName="autoPayHeader">
          <h1 styleName="title" data-at="auto-pay-main-title-review">Review Auto Pay Details</h1>
        </header>

        {SummeryTable}

        <section styleName="disclaimer" data-at="auto-pay-review-legal-text">
          BY CLICKING THE "CONFIRM" BUTTON BELOW, YOU ARE ELECTRONICALLY SIGNING AND AGREEING TO THIS RECURRING PAYMENT AUTHORIZATION. YOU ACKNOWLEDGE THAT YOU HAVE READ, PRINTED/SAVED, UNDERSTAND, AND AGREE TO BE BOUND BY THE TERMS OF THIS AUTHORIZATION. WE WILL EMAIL YOU A COPY OF THIS AUTHORIZATION TO THE EMAIL ADDRESS SPECIFIED BELOW AFTER YOU ELECTRONICALLY SIGN IT.  IF YOU DO NOT WISH TO MAKE RECURRING PAYMENTS, YOU SHOULD CLOSE THIS BROWSER SESSION.
        </section>

        <div styleName="actionsGroup">
          <RaisedButton
              data-at="cancel-btn"
              onClick={this.setAutoPayStep.bind(this, "PAYMENT_DETAILS")}
              disabled={this.state.paymentInProcess}>
              CANCEL
          </RaisedButton>
          <RaisedButton
              data-at="make-payment-btn"
              primary={true}
              onClick={this.submit.bind(this)}
              disabled={!this.state.validPaymentDetails || this.state.paymentInProcess}>
              CONFIRM
          </RaisedButton>
          {this.renderNotPayableDialog()}
        </div>
      </div>);
    }

    return (
      <div styleName="cardMakeAPayment">
        <header styleName="autoPayHeader">
          <div styleName="titleAndSwitch">
            {/* <div styleName="autoPaySwitchContainer" data-at="auto-pay-switch-wrapper">
              <span styleName={autoPay ? '' : 'active'}>OFF</span>
              <Switch data-at="auto-pay-switch" data-at-value={autoPay} styleName="auto-pay-switch" checked={autoPay} onChange={this.handleAutoPaySwithChange.bind(this)}/>
              <span styleName={autoPay ? 'active' : ''}>ON</span>
            </div> */}
          </div>
          {autoPay && <h2 data-at="your-next-payment-date" styleName="nextPaymentDateTitle">Your payment date: {moment(balance.paymentDueDate).format("MM/DD/YYYY")}</h2>}

          <Dialog theme={dialogTheme} active={this.state.autoPayMessageOn}>
            <div data-at="autopay-disable-dialog" styleName="dialogContent">
              <div data-at="autopay-disable-dialog-close" styleName="closeIcon" onClick={this.showAutoPayOffMessage.bind(this, false)}>&nbsp;</div>
              <header><h1 styleName="title" data-at="auto-pay-cant-disable-message-title">Disable Auto Pay</h1></header>
              <section data-at="auto-pay-cant-disable-message">
                To disable AutoPay for your Sunbit Card please email us at <a data-at="auto-pay-cant-disable-message-email" href="mailto:support@sunbit.com">support@sunbit.com</a> or call 855-678-9248.
              </section>
              <RaisedButton data-at="disable-auto-pay-dialog-back-btn" onClick={this.showAutoPayOffMessage.bind(this, false)}>
                BACK
              </RaisedButton>
            </div>
          </Dialog>
        </header>
        <div styleName="cardMakeAPaymentInner" data-at="card-make-a-payment-form">
          <section styleName="commonSection paymentMethodSection">
            <h2 styleName="sectionTitle">Card autopay method</h2>
            <PaymentMethodSelect selected={this.state.paymentMethod} selectedRedNote={this.getSelectedRedNote()} last4Digits={last4Digits || ''} onChange={this.handlePaymentMethodSelection} hasPaymentMethod={this.state.hasPaymentMethod} />
            {!autoPay && (
              <div styleName="re-enroll-info-box-container">
                <InfoBox
                  dataAt={"re-enroll-info-box"}
                  type={"warning"}
                  title={"You have un-enrolled from autopay."}
                  body={
                    "To re-enroll, please select the payment method you would like to use for your monthly automatic payments."
                  }
                ></InfoBox>
              </div>
            )}

            <div styleName="autopay-info-box-container">
              <InfoBox
                dataAt={"link-account-box"}
                type={"warning"}
                title={""}
                body={
                  "You can link bank accounts and manage payment methods in the Sunbit app."
                }/>
            </div>

          </section>
          <section styleName={`paymentDetailsSection`}>
            {this.state.paymentMethod === 'DEBIT' && <section>
              <h2 styleName="sectionTitle">New Debit Card Information</h2>
              <h3 styleName="autoPaySecondaryTitle newDebit">Enter New Debit Card Details Below</h3>
              <DebitCardForm name="debitCardDetails" onChange={this.handleDebitCardFormChange} />
            </section>}

            {/*
            // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
            {this.state.paymentMethod === 'RCC' && <section>
                <h2 styleName="sectionTitle">Enter New RCC Details Below</h2>
                <h3 styleName="autoPaySecondaryTitle newRCC">Enter New RCC Details Below</h3>
                <RCCForm value={this.state.rccDetails} onChange={this.handleRCCFormChange} />
            </section>}
          */}

          </section>


          <section styleName="commonSection">
            <h2 styleName="sectionTitle">Amount</h2>
            <AmountOptions
              selected={this.state.amountOption}
            />
            <div styleName="autopay-info-box-container">
              <InfoBox
                dataAt={"link-account-box"}
                type={"warning"}
                title={""}
                body={
                  "Easily set your monthly payment to the minimum due, statement balance, or a fixed amount in the Sunbit app."
                }/>
            </div>
          </section>
        </div>

        {showDisclaimer && <div styleName="autopay-disclaimer">
          <span styleName="disclaimer-text">
            By tapping "Save" you are electronically signing and agreeing to the {recurringPaymentAuthorizationLink}. You acknowledge that you have read, printed/saved, understand, and agree to be bound by the terms of this authorizations.
          </span>
        </div>}

        <div className="actionsGroup">
          <RaisedButton
            data-at="save-btn"
            primary={true}
            onClick={this.setAutoPayStep.bind(this, "REVIEW")}
            disabled={!this.state.validPaymentDetails}>
            SAVE
          </RaisedButton>
        </div>
      </div>
    );
  }
}

export default CardAutoPaySettings;

/* eslint-enable react/no-multi-comp */



// WEBPACK FOOTER //
// ./src/card/CardAutoPaySettings.js